/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Agent_TeamInputs */

const en_mk_nav_agent_team = /** @type {(inputs: Mk_Nav_Agent_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent teams & AI choices`)
};

const id_mk_nav_agent_team = /** @type {(inputs: Mk_Nav_Agent_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim agent & pilihan AI`)
};

/**
* | output |
* | --- |
* | "Agent teams & AI choices" |
*
* @param {Mk_Nav_Agent_TeamInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_agent_team = /** @type {((inputs?: Mk_Nav_Agent_TeamInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Agent_TeamInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_agent_team(inputs)
	return en_mk_nav_agent_team(inputs)
});